import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownTimer() {
  // Start from 23:59:24
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 24
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSecs = prev.seconds - 1;
        let newMins = prev.minutes;
        let newHours = prev.hours;
        if (newSecs < 0) {
          newSecs = 59;
          newMins -= 1;
        }
        if (newMins < 0) {
          newMins = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMins,
          seconds: newSecs
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-navy text-white py-6 px-6 border-y border-gold/20" data-id="element-57">
      <div className="max-w-3xl mx-auto text-center" data-id="element-58">
        <h3 className="text-gold font-bold text-xl mb-3 uppercase tracking-wider" data-id="element-59">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h3>

        <div className="flex justify-center items-center gap-3 md:gap-4 mb-4" aria-label="Contador de tiempo restante" data-id="element-60">
          <div className="flex flex-col items-center" data-id="element-61">
            <div className="bg-white/5 border border-gold/30 rounded-xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-[0_0_15px_rgba(201,168,76,0.15)] backdrop-blur-sm" data-id="element-62">
              <span className="font-display font-bold text-3xl md:text-4xl text-gold" aria-hidden="true" data-id="element-63">
                {format(timeLeft.hours)}
              </span>
            </div>
            <span className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase tracking-widest font-semibold" data-id="element-64">
              Horas
            </span>
          </div>
          <div className="text-gold/50 font-bold text-2xl md:text-3xl pb-6 md:pb-7 animate-pulse" data-id="element-65">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-66">
            <div className="bg-white/5 border border-gold/30 rounded-xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-[0_0_15px_rgba(201,168,76,0.15)] backdrop-blur-sm" data-id="element-67">
              <span className="font-display font-bold text-3xl md:text-4xl text-gold" aria-hidden="true" data-id="element-68">
                {format(timeLeft.minutes)}
              </span>
            </div>
            <span className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase tracking-widest font-semibold" data-id="element-69">
              Minutos
            </span>
          </div>
          <div className="text-gold/50 font-bold text-2xl md:text-3xl pb-6 md:pb-7 animate-pulse" data-id="element-70">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-71">
            <div className="bg-white/5 border border-danger/30 rounded-xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-[0_0_15px_rgba(239,68,68,0.15)] backdrop-blur-sm" data-id="element-72">
              <span className="font-display font-bold text-3xl md:text-4xl text-danger" aria-hidden="true" data-id="element-73">
                {format(timeLeft.seconds)}
              </span>
            </div>
            <span className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase tracking-widest font-semibold" data-id="element-74">
              Segundos
            </span>
          </div>
        </div>

        <p className="text-danger font-bold text-base mb-4 flex items-center justify-center gap-2" data-id="element-75">
          ⚠️ Después sube el precio. No vuelve.
        </p>

        <div className="bg-white/5 rounded-2xl p-4 border border-white/10" data-id="element-76">
          <div className="flex justify-between text-xs md:text-sm mb-1 font-medium" data-id="element-77">
            <span className="text-danger flex items-center gap-2" data-id="element-78">
              🔴 Plazas al precio de lanzamiento limitadas
            </span>
            <span className="text-white" data-id="element-79">72% tomadas</span>
          </div>
          <div className="w-full bg-white/10 rounded-full h-4 overflow-hidden" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} data-id="element-80">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '72%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} style={{
            willChange: 'width'
          }} className="bg-danger h-full rounded-full relative" data-id="element-81">
              <div className="absolute inset-0 bg-white/20 w-full animate-[shimmer_2s_infinite]" style={{
              backgroundImage: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)'
            }} data-id="element-82"></div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>;
}